export function getHouseMaterialType(materialType: string) {
  switch (materialType) {
    case 'block':
      return 'Блочный';
    case 'boards':
      return 'Щитовой';
    case 'brick':
      return 'Кирпичный';
    case 'monolith':
      return 'Монолитный';
    case 'monolithBrick':
      return 'Монолитно кирпичный';
    case 'old':
      return 'Старый фонд';
    case 'panel':
      return 'Панельный';
    case 'stalin':
      return 'Сталинский';
    case 'wood':
      return 'Деревянный';
    case 'aerocreteBlock':
      return 'Газобетонный блок';
    case 'foamConcreteBlock':
      return 'Пенобетонный блок';
    case 'gasSilicateBlock':
      return 'Газосиликатный блок';
    case 'wireframe':
      return 'Каркасный';
    default:
      return 'Не указано';
  }
}
